import { botLogos } from "../configs/botLogos";

export const calculateProgress = (
  currentDate: number,
  startDate: string | undefined,
  endDate: string | undefined
) => {
  if (!startDate || !endDate) return 0;
  const current = currentDate * 1000;
  const start = new Date(startDate.replace(/-/g, "/")).getTime();
  const end = new Date(endDate.replace(/-/g, "/")).getTime();
  if (current < start) {
    return 0;
  } else if (current > end) {
    return 100;
  } else {
    return Math.round(((current - start) / (end - start)) * 100);
  }
};

export const randomizeIcon = () => {
  const randomIndex = Math.floor(Math.random() * botLogos.length);
  return botLogos[randomIndex];
};
